import React from 'react';
import RollingGallery from './components/RollingGallery'
import './App.css';

function App() {
  return (
    <div className="App">
      <RollingGallery />
    </div>
  );
}

export default App;
